import { u as S } from "./JOBHIYEN.DiBKvV5J.js";
import { x as O, y as R } from "./YLXVVG22.DAM5w7Mj.js";
import { k as D, l as v, m as f, v as h, a3 as y, q as w, g as T, x as V, h as u, j as g, z as E, y as j } from "./7FZLUSKW.7Pws8uOI.js";
import { useRef as B, useState as M, useEffect as q } from "react";
var z = "button", H = Symbol("disclosure"), P = D(
  function(t) {
    var s = t, { store: e, toggleOnClick: r = !0 } = s, o = v(s, ["store", "toggleOnClick"]);
    const i = O();
    e = e || i, f(
      e,
      process.env.NODE_ENV !== "production" && "Disclosure must receive a `store` prop or be wrapped in a DisclosureProvider component."
    );
    const c = B(null), [x, C] = M(!1), a = e.useState("disclosureElement"), p = e.useState("open");
    q(() => {
      let n = a === c.current;
      a != null && a.isConnected || (e == null || e.setDisclosureElement(c.current), n = !0), C(p && n);
    }, [a, e, p]);
    const d = o.onClick, _ = h(r), [b, k] = y(o, H, !0), N = w((n) => {
      d == null || d(n), !n.defaultPrevented && (b || _(n) && (e == null || e.setDisclosureElement(n.currentTarget), e == null || e.toggle()));
    }), m = e.useState("contentElement");
    return o = T(u(u({
      "aria-expanded": x,
      "aria-controls": m == null ? void 0 : m.id
    }, k), o), {
      ref: V(c, o.ref),
      onClick: N
    }), o = S(o), o;
  }
);
g(function(t) {
  const s = P(t);
  return E(z, s);
});
var $ = "button", A = D(
  function(t) {
    var s = t, { store: e } = s, r = v(s, ["store"]);
    const o = R();
    e = e || o, f(
      e,
      process.env.NODE_ENV !== "production" && "DialogDisclosure must receive a `store` prop or be wrapped in a DialogProvider component."
    );
    const i = e.useState("contentElement");
    return r = u({
      "aria-haspopup": j(i, "dialog")
    }, r), r = P(u({ store: e }, r)), r;
  }
), K = g(function(t) {
  const s = A(t);
  return E($, s);
});
export {
  K as D,
  A as u
};
//# sourceMappingURL=35RDKJF6.CV6DV0ek.js.map
